import { devError } from '../utils';
// check if atoms value is empty
export function isValueEmpty(value, checkAnyObjectField = true) {
    return (value === undefined ||
        value === null ||
        (Array.isArray(value) && value.length === 0) ||
        // if it's not null or undefined, we check if it's an object
        // and if yes, we check if any values are empty
        (typeof value === 'object' &&
            checkAnyObjectField &&
            Object.values(value).reduce((res, v) => {
                if (v === undefined || v === null)
                    return true;
                return res;
            }, false)));
}
// helper to return a value
export function valueEmpty(value) {
    if (isValueEmpty(value)) {
        return null;
    }
    // we know that this value cannot be undefined/null
    return value;
}
// Merge elements over indices
export function mergeArrayIndices(arr, index, input) {
    return arr[index]
        ? [...arr].map((p, i) => (i === index ? input : p))
        : [...arr, input];
}
// first char to uppercase
export function capitalize(value) {
    if (typeof value !== 'string')
        return '';
    return value.charAt(0).toUpperCase() + value.slice(1);
}
export const filterArray = (items, filter) => {
    const fieldNames = Object.keys(filter);
    return items.filter((item) => {
        let isFound = true;
        for (let i = 0; i < fieldNames.length; i += 1) {
            const fieldName = fieldNames[i];
            if (item[fieldName] !== filter[fieldName]) {
                isFound = false;
            }
        }
        return isFound;
    });
};
export const findIndexByFilter = (items, filter) => {
    const fieldNames = Object.keys(filter);
    return items.findIndex((item) => {
        let isFound = true;
        for (let i = 0; i < fieldNames.length; i += 1) {
            const fieldName = fieldNames[i];
            if (item[fieldName] !== filter[fieldName]) {
                isFound = false;
            }
        }
        return isFound;
    });
};
export const alertOverwrite = (value, filter) => {
    const fieldNames = Object.keys(filter);
    const valueFieldNames = Object.keys(value);
    const overwriteErrorFields = [];
    for (let i = 0; i < fieldNames.length; i += 1) {
        if (valueFieldNames.includes(fieldNames[i])) {
            overwriteErrorFields.push(fieldNames[i]);
        }
    }
    if (overwriteErrorFields.length > 0) {
        devError('Warning - NMP - common/selectorFamily/set - Trying to overwrite filter this will not work. Related Fields:', overwriteErrorFields.join(','));
    }
};
